import { useState } from 'react'
import { DEFAULT_FORBIDDEN_WORDS } from '@/lib/amazon-title-validator'

export const FORBIDDEN_WORDS_STORAGE_KEY = 'goki_amazon_forbidden_words'

interface UseForbiddenWordsReturn {
  words: string[]
  addWord: (word: string) => void
  removeWord: (word: string) => void
  resetToDefault: () => void
}

export function useForbiddenWords(): UseForbiddenWordsReturn {
  const [words, setWords] = useState<string[]>(() => {
    try {
      const stored = localStorage.getItem(FORBIDDEN_WORDS_STORAGE_KEY)
      return stored ? (JSON.parse(stored) as string[]) : DEFAULT_FORBIDDEN_WORDS
    } catch {
      return DEFAULT_FORBIDDEN_WORDS
    }
  })

  const persist = (newWords: string[]) => {
    setWords(newWords)
    localStorage.setItem(FORBIDDEN_WORDS_STORAGE_KEY, JSON.stringify(newWords))
  }

  const addWord = (word: string) => {
    const trimmed = word.trim().toLowerCase()
    if (!trimmed || words.includes(trimmed)) return
    persist([...words, trimmed])
  }

  const removeWord = (word: string) => persist(words.filter((w) => w !== word))

  const resetToDefault = () => persist(DEFAULT_FORBIDDEN_WORDS)

  return { words, addWord, removeWord, resetToDefault }
}
